import React from "react";
import "./loader.css";
const Loader = (props) => {
  return <div className={`${props.className ? props.className : "loader"}`} />;
};

export default Loader;
